function hasUnsavedChanges(pref, coursesToAdd) {
  const prefIds = pref.map(p => p.course)
  const courseIds = coursesToAdd.map(c => c.id)

  const containsAll = (arr1, arr2) => arr2.every(arr2Item => arr1.includes(arr2Item))

  // check local storage for ranks
  const rankedCoursesStorage = localStorage.getItem('ranked_courses') || [];

  // if they have something in local storage (ew, not me) for ranked thats pending...
  // or if they don't match the same courses... that means they're not saved yet
  return rankedCoursesStorage.length || !(containsAll(prefIds, courseIds) && containsAll(courseIds, prefIds))
}

function getRequiredCreditsToProceed(max_course_units) {
  return Math.max(2 * max_course_units, 0.01)
}

function getCurrentSelectionWeight(coursesToAdd) {
  let weightSum = 0;
  coursesToAdd.map(c => {
    weightSum += c.weight;
  });

  return Math.round(weightSum * 100) / 100
}

function convertTimeToNewFormat(timeString) {
  // expects '10:00:00' format
  try {
    const timeSplit = timeString.split(':')
    const hours = ((parseInt(timeSplit[0], 10) + 11) % 12 + 1);
    var suffix = parseInt(timeSplit[0], 10) >= 12 ? 'PM' : 'AM'
    return `${hours}:${timeSplit[1]} ${suffix}`
  } catch (ex) {
    return timeString
  }
}

export {
  getRequiredCreditsToProceed,
  getCurrentSelectionWeight,
  convertTimeToNewFormat,
  hasUnsavedChanges
}


// WEBPACK FOOTER //
// ./src/components/common/utils.js